<template>
    <div class="container">
      <div class="img">
        <img src="@/assets/images/pages/with_love.svg">
      </div>
      <div class="signup-container">
        <div class="form">
          <Logo class="logo text-primary fill-current" />
          <h3>Create Account For Free</h3>
          <p>Create an account and start your social commerce journey now.</p>
          <div class="input-div mt-2">
            <div>
                <vs-input
                v-validate="'required|email|min:3'"
                data-vv-validate-on="blur"
                size="large"
                type="email"
                name="email"
                icon-pack="feather"
                icon="icon-mail"
                icon-no-border
                v-model="email"
                label-placeholder="EMAIL"
                :disabled="isInvited"
                class="w-full mt-4"/>
                <span class="text-danger text-sm float-left">{{ errors.first('email') }}</span>
            </div>
          </div>

          <div class="input-div mb-10">
            <div>
              <vs-input
                ref="password"
                v-validate="'required|min:6|max:255'"
                data-vv-validate-on="blur"
                size="large"
                type="password"
                name="password"
                icon-pack="feather"
                icon="icon-lock"
                icon-no-border
                v-model="password"
                label-placeholder="PASSWORD"
                class="w-full mt-6"/>
            <span class="text-danger text-sm float-left">{{ errors.first('password') }}</span>
            </div>
          </div>

          <div class="input-div mb-10">
            <div>
              <vs-input
                type="password"
                v-validate="'min:6|max:255|confirmed:password'"
                data-vv-validate-on="blur"
                data-vv-as="password"
                name="confirm_password"
                size="large"
                label-placeholder="CONFIRM PASSWORD"
                v-model="confirm_password"
                class="w-full mt-6"
                icon-pack="feather"
                icon="icon-lock"
                icon-no-border />
                <span class="text-danger text-sm float-left">{{ errors.first('confirm_password') }}</span>
            </div>
          </div>

          <div class="tnc-div">
            <div>
              <input type="checkbox" class="tnc" v-model="checkBox_tnc"/><span> I agreed to QuickSend <a href="/login">Terms of Service</a> and <a href="/forgot-password">Privacy Policy</a>.</span>
            </div>
          </div> 
        
          <div class="flex flex-wrap mt-10">
            <router-link to="/login">Already have account? Sign In here</router-link>
          </div>
          <vs-button class="shadow-md w-full mt-2" @click="signup(email,password)" :disabled="!validateForm">Sign Up</vs-button>
          <!-- <vs-divider class=" mt-2 mb-2 text-l text-bold" color="black">OR GO EASY WITH</vs-divider>
          <div class="flex flex-wrap justify-between">
            <vs-button color="#3b5998" class="facebook">Facebook</vs-button>
            <vs-button color="#db3236" class="google">Google</vs-button>
          </div>   -->
        </div> 
      </div>
    </div>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue';
import auth from '@/services/authService';
import axios from '@/axios'
import router from '@/router'

const dialogs = {
  expired: (error) => {
    return {
      color: "danger", 
      title: "Session Expired.",
      text: "Opps, you have missed the chance! Try to contact the owner to resend invitation.",
      accept:() => {
        router.push('/signup')
      },
      close:() => {
        router.push('/signup')
      }
    }
  }
}

export default {
  components: {
    Logo,
  }, 
  data () {
    return {
      email: '',
      password: '',
      confirm_password: '',
      checkBox_tnc: false,
      isInvited: false,
    }
  },
  created(){
    if(!localStorage.getItem('token')){
      return
    }else{
      const headers = { 'Content-Type' : 'application/json' }
      axios.post('/auth/invite_token_validity', { token: this.token }, {
        headers
      }).then((res) => {
        if(res.data.data === 'expired'){
          localStorage.removeItem('token')
          this.$vs.dialog(dialogs.expired())
        }else{
          this.email = res.data.data
					this.isInvited = true
        }
      }).catch((err) => { console.log(err) })
    }
  },
  computed: {
    validateForm(){
      return !this.errors.any() && this.email !== '' && this.password !== '' && this.confirm_password !== '' && this.checkBox_tnc === true
    },
    token(){
      return decodeURIComponent(localStorage.getItem('token'))
    }
  },
  methods: {
    signup (email, password) {
      if (!this.validateForm) return;
      
      if(this.isInvited){
        auth.signup(email, password, this.token).then(() => {
          router.push({ path: '/signup/verify' });
        }).catch(error => {
          if (typeof error.message === 'undefined') {
            error.message = "Cannot register using this email";
          }

          this.$vs.notify({
            title: 'Signup Failed',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }else{
        auth.signup(email, password).then(() => {
          router.push({ path: '/signup/verify' });
        }).catch(error => {
          if (typeof error.message === 'undefined') {
            error.message = "Cannot register using this email";
          }

          this.$vs.notify({
            title: 'Signup Failed',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
      }
    },
  }
}
</script>

<style scoped>
* {
    padding:0;
    margin: 0;
    box-sizing: border-box;
}
body {
  display:grid;
  width: 100%;
  height: 100%;
}

.withlove {
  position:fixed;
  height: 100%;
  left: 0;
  bottom:0;
  z-index: -1;
}

.container {
  margin: auto;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-template-areas: "image form";
    grid-gap: 10rem;
    padding: 0 2rem;
}

.img{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    grid-area: image;
}

.img img{
   width: 600px; 
}

.signup-container {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 30px;
    margin-bottom: 30px;
    grid-area: form;
}

.form{
    width:360px;
}

.logo {
    width: 150px;
    place-items: center;
}

.input-div{
    display: grid;
    margin: 25px 0;
    padding: 5px 0;
}


.input-div > div {
    position: relative;
    height: 45px;

}

input[type=checkbox]{
  box-sizing: border-box;
  padding: 0;
}

input[type=checkbox].tnc:checked{
  border-color: #f9278e;
  background-color:#f9278e;
}

/* .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555555;
} */


a{
  color: #999999;
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
}

a:hover{
  color:#f9278e;
}


@media screen and (max-width: 1050px) {
    .container{
        grid-gap: 5rem;
    }
}

@media screen and (max-width: 1000px) {
    .form{
        width: 290px;
    }

    .form h3{
        font-size: 1.2rem;
    }
    .img img{
        width: 400px;
    }
}

@media screen and (max-width: 900px) {
    .img{
        display:none;
    }
    .container{
        display: inherit;
    }
    .signup-container{
        justify-content: center;
    }
}
</style>
